/** @format */

import { get } from 'lodash';

const host = window.document.location.host ? window.document.location.host : '';

export const isLocal = host.indexOf('raygun.local') !== -1 || host.indexOf('localhost') !== -1;

export const isBeta = host.indexOf('app.beta') !== -1;

export const isIntegrationTest = get(window, 'RaygunConfiguration.Environment', '') === 'E2E';
